export default "__VITE_ASSET__e44152b4__"